export default "/images/reports-active-light.svg?d541fd1661195208e9c352887daf08ff";